import React, { Fragment, PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { msg } from 'api';
import SubscriptionsQuantityInputContainer from '../../containers/SubscriptionsQuantityInputContainer';
import SubscriptionsFrequencySelect from '../../containers/SubscriptionsFrequencySelect';

import { BUTTON_DISABLED, QUANTITY_INPUT, BUTTON } from './SubscribeControlsType';
import { NEVER } from './SubscriptionsFrequencyOptions';

export default class SubscribeControls extends PureComponent {
  static propTypes = {
    sku: PropTypes.string.isRequired,
    frequency: PropTypes.string.isRequired,
    onSubscribe: PropTypes.func.isRequired,
    isNewDesign: PropTypes.bool,
    forceChooseFrequency: PropTypes.bool,
    type: PropTypes.oneOf([BUTTON, BUTTON_DISABLED, QUANTITY_INPUT]),
    isRecommendation: PropTypes.bool,
  };

  subscribe = () => {
    const { onSubscribe, sku, frequency } = this.props;
    onSubscribe(sku, frequency);
  };

  generateDefaultControl() {
    const {
      sku,
      forceChooseFrequency,
      onSubscribe,
      type,
      isRecommendation,
    } = this.props;

    return forceChooseFrequency ? (
      <SubscriptionsFrequencySelect
        sku={sku}
        forceChooseFrequency={forceChooseFrequency}
        onSubscribe={onSubscribe}
        frequency={NEVER}
        isRecommendation={isRecommendation}
      />
    ) : (
      <Fragment>
        <SubscriptionsFrequencySelect
          sku={sku}
          isRecommendation={isRecommendation}
        />
        <button
          type="submit"
          className="sub-fop__button subL-fop__button"
          disabled={type === BUTTON_DISABLED}
          onClick={this.subscribe}
        >
          {msg.subscriptions.fop.subscribeButton}
        </button>
      </Fragment>
    );
  }

  generateQuantityInputControl() {
    const {
      sku,
      forceChooseFrequency,
      onSubscribe,
      isRecommendation,
    } = this.props;

    return forceChooseFrequency ? (
      <Fragment>
        <SubscriptionsQuantityInputContainer sku={sku} isRecommendation={isRecommendation} />
        <SubscriptionsFrequencySelect
          sku={sku}
          forceChooseFrequency={forceChooseFrequency}
          onSubscribe={onSubscribe}
          isRecommendation={isRecommendation}
        />
      </Fragment>
    ) : (
      <Fragment>
        <SubscriptionsFrequencySelect sku={sku} isRecommendation={isRecommendation} />
        <SubscriptionsQuantityInputContainer sku={sku} isRecommendation={isRecommendation} />
      </Fragment>
    );
  }

  render() {
    const {
      type,
      isNewDesign,
    } = this.props;

    return (
      <div className="fop-add-default">
        <div
          className={classNames(
            'fop-subscription-wrapper',
            { 'fop-subscription-wrapper--newDesign': isNewDesign },
          )}
        >
          {type === QUANTITY_INPUT
            ? this.generateQuantityInputControl()
            : this.generateDefaultControl()
          }
        </div>
      </div>
    );
  }
}
